import { render, staticRenderFns } from "./YourEmail.vue?vue&type=template&id=47837209&scoped=true&"
import script from "./YourEmail.vue?vue&type=script&lang=js&"
export * from "./YourEmail.vue?vue&type=script&lang=js&"
import style0 from "./YourEmail.vue?vue&type=style&index=0&id=47837209&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47837209",
  null
  
)

export default component.exports